import * as React from 'react'

export const ErrorPage = () => <h1>Something went wrong.</h1>
